<template>
  <figure class="qrcode">
    <qrcode
      :value="json"
      :options="{
        errorCorrectionLevel: 'Q',
        width: 200,
      }"
    ></qrcode>
    <img
      class="qrcode__image"
      src="/dole.jpg"
      alt="Chen Fengyuan"
    />
  </figure>
</template>
<script>
export default {
    data() {
        return {
            array: {
                hello: 'arjay'
            }
        }
    },
    computed: {
        json(){
            return JSON.stringify(this.array)
        }
    }
}
</script>
<style scoped>
.qrcode {
  display: inline-block;
  font-size: 0;
  margin-bottom: 0;
  position: relative;
}

.qrcode__image {
  background-color: #fff;
  border: 0.05rem solid #fff;
  border-radius: 0.25rem;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.25);
  height: 20%;
  left: 50%;
  overflow: hidden;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 20%;
}
</style>